/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_EmptyInputs */

const en_us2_swap_empty = /** @type {(inputs: Swap_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No alternatives here.`)
};

const pt_br2_swap_empty = /** @type {(inputs: Swap_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem alternativas por aqui.`)
};

const es_419_swap_empty = /** @type {(inputs: Swap_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay alternativas aquí.`)
};

const pt_pt2_swap_empty = /** @type {(inputs: Swap_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem alternativas aqui.`)
};

const fr_fr2_swap_empty = /** @type {(inputs: Swap_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune alternative ici.`)
};

const de_de2_swap_empty = /** @type {(inputs: Swap_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier gibt es keine Alternativen.`)
};

const it_it2_swap_empty = /** @type {(inputs: Swap_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna alternativa qui.`)
};

/**
* | output |
* | --- |
* | "No alternatives here." |
*
* @param {Swap_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_empty = /** @type {((inputs?: Swap_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_empty(inputs)
	if (locale === "es-419") return es_419_swap_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_empty(inputs)
	if (locale === "de-DE") return de_de2_swap_empty(inputs)
	if (locale === "it-IT") return it_it2_swap_empty(inputs)
	return en_us2_swap_empty(inputs)
});
export { swap_empty as "swap.empty" }